<!--
 * @Descripttion: 
 * @version: 1.0
 * @Author: Erik Zhang
 * @Date: 2021-02-14 23:36:16
 * @LastEditors: Erik Zhang
 * @LastEditTime: 2021-04-05 15:19:35
-->
<template>
  <edu-layout type="table">
    <veHqHaopinCr viewType="ru" slot="table"></veHqHaopinCr>
  </edu-layout>
</template>

<script>
import veHqHaopinCr from './base/veHqHaopinCr';
export default {
  components: {
    veHqHaopinCr
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {}
};
</script>
<style lang="less" scoped></style>
